<template>
  <div class="one-menu-box">
    <Header v-if="!isIframe"></Header>
    <div :class="['content-box-page', {'no-header': isIframe}]">
      <leftMenu  :paths="paths"> </leftMenu>
      <div class="router-view-box float-left">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from "../header/index.vue";
import leftMenu from "../leftMenu/index.vue";
export default {
  name: "App",
  components: {
    Header,
    leftMenu,
  },
  data(){
    return {
      paths: [],
    }
  },
  computed: {
    ...mapGetters(['isIframe']),
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newval, oldval)  {
        
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.one-menu-box {
  width: 100%;
  height: 100%;
  .content-box-page {
    height: calc(100% - 50px);
    background: #f5f6fa;
    .router-view-box {
      width: calc(100% - 164px - 16px);
      height: 100%;
      background: #f5f6fa;
      padding: 16px;
      overflow: auto;
    }
  }
  .no-header {
    height: 100%;
  }
}
</style>